<script>
	import { field, form } from "svelte-forms";
	import { required } from "svelte-forms/validators";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	import { extractErrorMessage } from "src/utils/misc";
	import { onMount } from "svelte";
	import { navigate } from "svelte-routing";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import CustomInput from "../../../components/CustomInput/CustomInput.svelte";
	import CustomSelect from "../../../components/CustomSelect/CustomSelect.svelte";
	import CustomTextArea from "../../../components/CustomTextArea/CustomTextArea.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import client from "../../../services/client";
	import { errorMessage, loading, toastMessage } from "../../../store/store";

	export let isEdit;

	const description = field("description", "", [required()]);
	const taskCategory = field("taskCategory", "", [required()]);
	const imageUpload = field("imageUpload", true, [required()]);
	const instructions = field("instructions", "", [required()]);
	const remarks = field("remarks", "", [required()]);

	let descriptionError;
	let taskCategories;

	let load = false;
	loading.subscribe((value) => {
		load = value;
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	const myForm = form(
		description,
		taskCategory,
		imageUpload,
		instructions,
		remarks
	);

	async function fetchLookups() {
		try {
			const res = await client("/v1/tasks/lookups", {
				method: "GET",
				version: "Tasking",
			});
			taskCategories = res.data.taskCategories.map((item) => {
				return {
					value: item.id,
					label: item.name,
				};
			});
		} catch (err) {
			console.log(err.response);
		}
	}

	async function fetchTaskDetails() {
		try {
			const res = await client(`/v1/presetTasks/${isEdit}`, {
				method: "GET",
				version: "Tasking",
			});
			$description.value = res.data.description;
			$taskCategory.value = res.data.taskCategoryId;
			$imageUpload.value = res.data.requireMediaUpload;
			$instructions.value = res.data.instructions;
		} catch (err) {
			console.log(err.response);
		}
	}

	async function handleSubmit() {
		try {
			const url = isEdit
				? `/v1/presetTasks/${isEdit}`
				: "/v1/presetTasks";

			const message = isEdit
				? "Changes successfully saved"
				: "New preset task added";
			loading.set(true);
			const res = await client(url, {
				method: isEdit ? "PUT" : "POST",
				version: "Tasking",
				data: {
					description: $description.value,
					taskCategoryId: $taskCategory.value,
					requireMediaUpload: $imageUpload.value,
					instructions: $instructions.value,
				},
			});

			if (res.status === 204) {
				loading.set(false);
				toastMessage.set({ message, type: "success" });
				navigate("/master-data/preset-task");
			}
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
			console.log(err.response);
		}
	}

	errorMessage.subscribe((value) => {
		err = value;
	});

	$: isValid =
		$description.value && $taskCategory.value && $instructions.value;

	onMount(async () => {
		await fetchLookups();
		if (isEdit) {
			fetchTaskDetails();
		}
	});
</script>

<Row>
	<Col>
		<PageHeader title={`${isEdit ? "Edit" : "Create"} Task`} />
		<ErrorMessageHandler message={err} />
		<div class="taskform-container">
			<Col>
				<Row>
					<Col>
						<label for="mobile" class="d-block">
							<span>
								Description<span style="color: red">*</span
								></span
							>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$description.value}
							error={$myForm.hasError("description.required") ||
								descriptionError}
							errorText={$myForm.hasError("description.required")
								? "Description is required"
								: descriptionError
									? "Task description already exists"
									: ""}
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="priority" class="d-block pt-2">
							<span>
								Task Category<span style="color: red">*</span>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomSelect
							type="text"
							options={taskCategories}
							bind:value={$taskCategory.value}
							error={$myForm.hasError("taskCategory.required")}
							errorText="Category is required"
							defaultOption="Select a category"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="imageUpload" class="d-block pt-2">
							<span>
								Image Upload<span style="color: red">*</span>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<div class="my-2">
							<label>
								<input
									type="radio"
									name="blackout-car"
									id="blackout-yes"
									value={true}
									class="mx-3"
									bind:group={$imageUpload.value}
								/>
								<span>Yes</span>
							</label>
							<label>
								<input
									type="radio"
									name="blackout-car"
									id="blackout-no"
									value={false}
									class="mx-3"
									bind:group={$imageUpload.value}
								/>
								<span>No</span>
							</label>
						</div>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="mobile" class="d-block pt-2">
							<span
								>Instructions<span style="color: red">*</span
								></span
							>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomTextArea
							bind:value={$instructions.value}
							error={$myForm.hasError("instructions.required")}
							errorText="Instructions are required"
						/>
					</Col>
				</Row>
			</Col>
			<Col class="d-flex my-2">
				<Row>
					<Col>
						<CustomButton
							buttonText={`${isEdit ? "Save" : "Create"}`}
							on:click={handleSubmit}
							disabled={!isValid}
							color="primary"
							onKeyDown={handleSubmit}
						/>
					</Col>
				</Row>
			</Col>
		</div></Col
	>
</Row>

<style>
	.taskform-container {
		padding: 20px;
		border: 1px solid #e8e8e8;
		border-radius: 8px;
	}
</style>
